module.exports = __webpack_public_path__ + "img/bgimg1.3dcdb40e.png";